import { render } from "./TourPermits.vue?vue&type=template&id=7399273c"
import script from "./TourPermits.vue?vue&type=script&lang=js"
export * from "./TourPermits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__